<div class="row" *ngIf="notification">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'NOTIFICATION.NOTIFICATION' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-back" routerLink="/notifications">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-3">
                        <div class="notification-info-title"> Сообщения</div>
                    </div>

                    <div class="col-9">
                        <div [innerHTML]="notification" [color]="yellow"></div>
                    </div>
                </div>

                <div class="org-info">
                    <!-- <div class="org-info-value content">{{ notification.notification_content.content.message }}</div> -->
                </div>
            </div>
        </div>

    </div>
</div>

<div *ngIf="!notification">
    <div *ngIf="loading"> {{ 'LOADING' | translate }}</div>
    <div *ngIf="!loading">{{ 'DATA_NOT_FOUND' | translate }}</div>
</div>